import axios from './axios.service';

export default class Offers {
  /**
   * get list of all popular offers
   * @returns promise
   */
  static getPopular() {
    return axios.get('/api/v2/cmt-backend/offers/popular/priority');
  }
  /**
   * get list of all Onboarding offers
   * @returns promise
   */
  static getOnboarding() {
    return axios.get('/api/v2/cmt-backend/offers/onboarding');
  }

  /**
   * save all Onboarding offers
   * @returns promise
   */
  static saveOnboardingOrder(onboardingOfferList) {
    return axios.put(
      '/api/v2/cmt-backend/offers/onboarding',
      onboardingOfferList,
    );
  }

  /**
   * get list of all regular offers
   * @returns promise
   */
  static getRegular(filters) {
    return axios.get('/api/v2/cmt-backend/offers/regular/all', {
      params: { ...filters },
    });
  }

  /**
   * get single offer
   * @param {Number} offerId
   * @returns promise
   */
  static getById(offerId) {
    return axios.get(`/api/v2/cmt-backend/offers/${offerId}`);
  }

  /**
   * get single Regular offer
   * @param {Number} offerId
   * @returns promise
   */
  static async getRegularById(offerId) {
    const result = await axios.get(
      `/api/v2/cmt-backend/offers/regular/${offerId}`,
    );
    return result?.data;
  }

  /**
   * get single Regular offer
   * @param {Number} offerId
   * @returns promise
   */
  static async getLuckyOneCardById(offerId) {
    const result = await axios.get(
      `/api/v2/cmt-backend/offers/lucky-one-card/${offerId}`,
    );
    return result?.data;
  }

  /**
   * save a list of all popular offers
   * @param {Array} popularOffersList
   * @returns promise
   */
  static savePopular(popularOffersList) {
    return axios.put(
      '/api/v2/cmt-backend/offers/popular/priority',
      popularOffersList,
    );
  }
  /**
   * get settings for offers
   * @returns promise
   */
  static getSettings() {
    return axios.get('/api/v2/cmt-backend/offers/settings');
  }

  /**
   * get offer tags
   * @returns promise
   */
  static getOfferTags() {
    return axios.get('/api/v2/cmt-backend/offers/tags/list');
  }

  /**
   * Create a new regular offer
   * @param {Object} offer payload
   * @returns  promise
   */
  static saveRegularOffer(offer) {
    return axios.post('/api/v2/cmt-backend/offers', offer);
  }

  static updateRegularOffer(offerId, offerPayload) {
    return axios.put(`/api/v2/cmt-backend/offers/${offerId}`, offerPayload);
  }

  /**
   * Deletes a new regular offer
   * @param {Number} offerId
   * @param {boolean} isSoftDeleted
   * @returns  promise
   */
  static deleteRegularOfferById(offerId, isSoftDeleted) {
    return axios.delete(
      `/api/v2/cmt-backend/offers/${offerId}?isSoftDeleted=${isSoftDeleted}`,
    );
  }

  static deleteLOCOfferById(offerId) {
    return axios.delete(`/api/v2/cmt-backend/offers/lucky-one-card/${offerId}`);
  }

  /**
   * Create a new LOC offer
   * @param {Object} offer payload
   * @returns  promise
   */
  static saveLOCOffer(offer) {
    return axios.post('/api/v2/cmt-backend/offers/lucky-one-card', offer);
  }

  /**
   * Update LOC offer
   * @param {number} offerId
   * @param {number} offerPayload
   * @returns  promise
   */
  static updateLOCOffer(offerId, offerPayload) {
    return axios.put(
      `/api/v2/cmt-backend/offers/lucky-one-card/${offerId}`,
      offerPayload,
    );
  }

  /**
   * Upload offers in bulk
   * @param {Binary} file File
   * @returns  promise
   */
  static uploadCMTOffersInBulk(file) {
    const bodyFormData = new FormData();
    bodyFormData.append('file', file);

    return axios.post(`/api/v2/cmt-backend/offers/bulk`, bodyFormData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
      },
    });
  }

  /**
   * Upload card offers in bulk
   * @param {Binary} file File
   * @returns  promise
   */
  static uploadCardOffersInBulk(file) {
    const bodyFormData = new FormData();
    bodyFormData.append('file', file);

    return axios.post(
      `/api/v2/cmt-backend/files/bulk-upload?feature=CardOfferStrategy`,
      bodyFormData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
        },
      },
    );
  }

  /**
   * create a custom category
   * @returns promise
   */
  static async createCustomCategory(body) {
    const result = await axios.post(
      '/api/v2/cmt-backend/offers/custom-category/new',
      body,
    );
    return result?.data;
  }

  /**
   * update a custom category
   * @returns promise
   */
  static async updateCustomCategory(id, body) {
    const result = await axios.put(
      `/api/v2/cmt-backend/offers/custom-category/${id}`,
      body,
    );
    return result?.data;
  }

  /**
   * get one custom category
   * @returns promise
   */
  static async getLastCustomCategory() {
    const result = await axios.get(
      `/api/v2/cmt-backend/offers/custom-category/last`,
    );
    return result?.data;
  }
}
